module.exports = __webpack_public_path__ + "img/close.9ba46390.svg";